import React from 'react';
import ButtonBlock from './ButtonBlock';

const TextCtaBlock = ({ data }) => {
  return (
    <div className="text-cta-block">
      <div className="text-cta-block__inner has-text-centered">
        <h2 className="is-size-2 is-size-4-touch has-text-weight-bold mb-2">{data.title}</h2>
        <div className="mb-3">
          {data.subtitle.map((sub, index) => (
            <h4 className="orange has-text-weight-bold section__desc is-size-2 is-size-4-touch mb-2 lh-1" key={index}>{sub}</h4>
          ))}
        </div>
        <div className="mb-3">
          {data.description.map((paragraph, index) => (
            <p className="is-size-4 is-size-6-touch has-text-weight-bold mb-2 lh-1" key={index}>{paragraph}</p>
          ))}
        </div>
        <div className="pb-3 is-hidden-mobile">
          {data.smalldesc.map((small, index) => (
            <p className="section__desc is-size-5 mb-1 lh-1" key={index}>{small}</p>
          ))}
        </div>
        {data.button && <ButtonBlock text={data.button.text} link={data.button.link} />}
      </div>
    </div>
  );
};

export default TextCtaBlock;